import React from "react";
import MsTeamsErrorSvg from "../../shared/svg/MsTeamsErrorSvg";
import styles from "./outsideMsTeams.module.scss";
import { useTranslation } from "../../shared/translation/Translation";

const OutsideMsTeams: React.FC<{}> = () => {
    const messages = useTranslation();

    return (
        <div className={styles.wrapper}>
            <MsTeamsErrorSvg className={styles.svg} />
            <h2 style={{ textAlign: "center" }}>{messages.appOutsideMsTeams.message}</h2>
        </div>
    );
};

export default OutsideMsTeams;
